 <template>
  <a-form :form="form" @submit="handleSubmit">
    <a-form-item label="账号" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <a-input
        v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入你的账号!' }]}
        ]"
      />
    </a-form-item>
    <a-form-item label="密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <a-input
        v-decorator="[
          'passwrod',
          {rules: [{ required: true, message: '请输入你的密码!' }]}
        ]"
      />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 12, offset: 9 }">
      <a-button type="primary" html-type="submit">登陆</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      form: this.$form.createForm(this)
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$router.push({ path: '/work' })
        }
      })
    }
  }
}
</script>
